import { store } from '@/store';

const contentful = require('contentful');

// Contentful space Swish Portal
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_PORTAL_SPACE_ID,
  accessToken: process.env.VUE_APP_CONTENTFUL_PORTAL_ACCESS_TOKEN,
  host: process.env.VUE_APP_CONTENTFUL_HOST,
  environment: process.env.VUE_APP_CONTENTFUL_PORTAL_ENV,
});

export const getGuideContentBySlug = async (slug) => {
  const locale = store.state.locale.currentLocale;

  try {
    const resp = await client.getEntries({
      content_type: 'guideContent',
      select: 'sys.id,fields',
      'fields.slug': slug,
      locale,
    });
    return resp.items[0] ? resp.items[0].fields.content : [];
  } catch (error) {
    throw new Error(error);
  }
};

export const getPageBySlug = async (slug) => {
  const locale = store.state.locale.currentLocale;

  try {
    const resp = await client.getEntries({
      content_type: 'page',
      select: 'sys.id,fields',
      'fields.slug': slug,
      locale,
    });

    return resp.items[0] ? resp.items[0].fields.content : [];
  } catch (error) {
    throw new Error(error);
  }
};

export const getBankByBic = async (bic) => {
  try {
    const resp = await client.getEntries({
      content_type: 'bank',
      select: 'sys.id,fields',
      'fields.bic': bic,
    });
    return resp.items[0] ? resp.items[0].fields : [];
  } catch (error) {
    throw new Error(error);
  }
};
